// extracted by mini-css-extract-plugin
export default {"photoHolder":"RnLN4n","label":"KPN7vL","content":"tkOwpR"};